import create from "zustand";

type TooltipType = "top" | "right" | "bottom" | "left";
type tooltipInfo = {
  top: null | number;
  left: null | number;
  type: null | TooltipType;
  tooltipText: string;
  bigFont: boolean;
} | null;

interface Tooltip {
  tooltipInfo: tooltipInfo;
  setTooltipInfo: (values: tooltipInfo | null) => void;
}

export const useTooltip = create<Tooltip>(set => ({
  tooltipInfo: null,
  setTooltipInfo: values =>
    set(() => ({
      tooltipInfo: values,
    })),
}));
